import axiosInstance from "./api/axiosInstance";

const createContractReceipt = async (formData) => {
  // O axiosInstance já injeta o token e gerencia o multipart/form-data
  const response = await axiosInstance.post("receipt/contract", formData);
  return response.data;
};

export const receiptService = {
  createContractReceipt,
};
